const axios = require('axios');
import config from '@/config.js'
import router from '@/router/routes'
import useEventBus from '@/composables/useEventBus.js'
const { emitEvent } = useEventBus();
import NProgress from 'nprogress';
import { getUserLogin } from '@/helper.js'

function _normalizeResponse(resp) {
	// Ensure resp is an object and always has messages as an array
	if (!resp) return { messages: [] };
	// If backend returned `message` as a string, convert to `messages` array
	if (!resp.messages && resp.message) {
		resp.messages = Array.isArray(resp.message) ? resp.message : [resp.message];
	}
	// If messages exist but is a string, wrap it
	if (resp.messages && typeof resp.messages === 'string') {
		resp.messages = [resp.messages];
	}
	if (!resp.messages) resp.messages = [];
	// Ensure `data` always exists: some endpoints return payload directly without a `data` wrapper
	if (typeof resp.data === 'undefined') {
		// Heuristic: if resp has fields that look like a resource (id, access_token, token_type, user_name...), treat whole resp as data
		const resourceKeys = ['id', 'access_token', 'token_type', 'user_name', 'email', 'name'];
		const hasResourceKey = Object.keys(resp).some(k => resourceKeys.includes(k));
		if (hasResourceKey) {
			resp = { data: resp, messages: resp.messages };
		} else {
			// No data and no resource-like keys: ensure data is null
			resp.data = null;
		}
	}
	return resp;
}

export default {
	_getHeaders() {
		// Use safe helper to get parsed user from localStorage
		var user = getUserLogin();

		let headers = {};
		if (user !== null) {
			headers.Authorization = 'Bearer ' + user.access_token;
		}
		return headers;
	},
	get(url, isLoad = false) {
		this.startLoading(isLoad);
		return new Promise((resolve, reject) => {
			axios.get(
				config.API_URL + url,
				{
					headers: this._getHeaders()
				}
			)
				.then(response => {
					this.endLoading(isLoad);
					resolve(_normalizeResponse(response.data));
				})
				.catch(error => {
					this.endLoading(isLoad);
					if (error && error.response && error.response.status == 401) this.hadleError401();
					else reject(error && error.response ? error.response.data : error);
				})
				.finally(() => {
					this.endLoading(isLoad);
				});
		});
	},
	post(url, data = {}, isLoad = false) {
		this.startLoading(isLoad);
		return new Promise((resolve, reject) => {
			axios.post(
				config.API_URL + url,
				data,
				{
					headers: this._getHeaders()
				}
			)
				.then(response => {
					this.endLoading(isLoad);
					resolve(_normalizeResponse(response.data));
				})
				.catch(error => {
					this.endLoading(isLoad);
					if (error && error.response && error.response.status == 401) this.hadleError401();
					else reject(error && error.response ? error.response.data : error);
				})
		})
	},
	put(url, data = {}, isLoad = false) {
		this.startLoading(isLoad);
		return new Promise((resolve, reject) => {
			axios.put(
				config.API_URL + url,
				data,
				{
					headers: this._getHeaders()
				}
			)
				.then(response => {
					this.endLoading(isLoad);
					resolve(_normalizeResponse(response.data));
				})
				.catch(error => {
					this.endLoading(isLoad);
					if (error && error.response && error.response.status == 401) this.hadleError401();
					else reject(error && error.response ? error.response.data : error);
				})
		})
	},
	patch(url, data = {}, isLoad = false) {
		this.startLoading(isLoad);
		return new Promise((resolve, reject) => {
			axios.patch(
				config.API_URL + url,
				data,
				{
					headers: this._getHeaders()
				}
			)
				.then(response => {
					this.endLoading(isLoad);
					resolve(_normalizeResponse(response.data));
				})
				.catch(error => {
					this.endLoading(isLoad);
					if (error && error.response && error.response.status == 401) this.hadleError401();
					else reject(error && error.response ? error.response.data : error);
				})
		})
	},
	delete(url, data = {}, isLoad = false) {
		this.startLoading(isLoad);
		return new Promise((resolve, reject) => {
			axios.delete(
				config.API_URL + url,
				data,
				{
					headers: this._getHeaders()
				}
			)
				.then(response => {
					this.endLoading(isLoad);
					resolve(_normalizeResponse(response.data));
				})
				.catch(error => {
					this.endLoading(isLoad);
					if (error && error.response && error.response.status == 401) this.hadleError401();
					else reject(error && error.response ? error.response.data : error);
				})
		})
	},

	hadleError401() {
		const { emitEvent } = useEventBus();
		emitEvent('eventError', 'Error Unauthorized !');
		window.localStorage.removeItem('user');
		setTimeout(() => {
			router.push({ name: "UserLogin" });
		}, 1500);
	},

	startLoading(isLoad) {
		NProgress.start() // NProgress thì luôn load thì call api  
		if (isLoad) { // Loading thì có thể load hoặc không tùy yêu cầu 
			emitEvent('eventLoading', true);
		}
	},

	endLoading(isLoad) {
		NProgress.done()
		if (isLoad) {
			emitEvent('eventLoading', false);
		}
	}
}

/*
Note : 
	get(url,isLoad=false){
	post(url, data = {}, isLoad=false){
	put(url, data = {}, isLoad=false){
	patch(url, data = {}, isLoad=false){
	delete(url, data = {}, isLoad=false){

	UserRequest.post('user/login', this.loginUser) // mặc định isLoad = false => không load 
	UserRequest.get('user/profile') // không load 

	UserRequest.post('user/login', this.loginUser, true) // có load 
	UserRequest.get('user/profile', true) // có load 


*/

